export default __webpack_public_path__ + "media/client-hub-logo.d5400.png";